import React, { PropsWithChildren } from "react";
import { ConfigProvider } from "antd";

const AntdProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#0C4A6E",
          colorText: "#0C4A6E",
          fontSize: 16,
          borderRadius: 4,
          fontFamily: "'Inter', sans-serif",
        },
        components: {
          Alert: {
            colorSuccessBg: "#F0FDF4",
            colorWarningBg: "#FFF7ED",
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default AntdProvider;
